import { StatusTradeTrust } from "actions";
import { Input, Modal } from "components/common"
import { ActiveShipmentsContext, DocumentsContext, HomeContext, ModalContext } from "contexts";
import { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form"
import { useLocation } from "react-router-dom";

export const EndorseOwnership = ({open, onCancel}) => {

    const [endorseOwnerShipName, setEndorseOwnerShipName] = useState('');
    const { parties, documentInfo, doDirectEndorsementChain } = useContext(DocumentsContext);
    const { walletVerify, setCallbackParties, setPleaseAwait, setStatusBlockChain, setCurrentStatus } = useContext(HomeContext);
    const { walletsFormat } = useContext(ActiveShipmentsContext);
    const { setEndorseOwnership } = useContext(ModalContext);
    const location = useLocation();
    const pathnameArr = location.pathname.split('/');
    const docId = pathnameArr[pathnameArr.length - 1];

    const { handleSubmit } = useForm();

    useEffect(() => {
        setEndorseOwnerShipName(walletsFormat?.find(x => x.address.toLowerCase().includes(parties?.nominatedOwner))?.value);
    },[open, walletsFormat, parties]);

    const handlConfirm = () => {
        const payload = {
            merkleRoot:documentInfo?.merkleRoot,
            newHolder:parties?.currentHolder,
            newOwner:parties?.nominatedOwner,
            organizationId:walletVerify?.orgId,
            tokenRegistryAddress:documentInfo?.tokenRegistryAddress,
            walletPassword:documentInfo?.walletPassword,
            isDemo:false
        };
        if(docId){
            doDirectEndorsementChain(docId, payload, walletVerify?.address, "Ethereum", walletVerify?.orgId, (data) => {
                if(data){
                    setPleaseAwait(true);
                    setCallbackParties(true);
                    setStatusBlockChain([
                        {key: 6, value: 'Please wait...'}
                    ]);
                    setStatusBlockChain([{key: 6, value: 'owner endorsement started'}]);
                    setCurrentStatus(StatusTradeTrust.OWNER_ENDORSEMENT_STARTED);
                    setEndorseOwnership(false);
                }
            });
        }
    }

    return (
        <Modal
            title="Endorse Ownership"
            open={open}
            className="tr__Endorse_Ownership"
            onCancel={onCancel}
            submitButton
            submitButtonLabel="Comfirm"
            isBackDropClickable={false}
            renderForm={children => (
                <form onSubmit={handleSubmit(handlConfirm)}>
                    {children}
                </form>
            )}

        >
            <Input
                label="Endorsing ownership to this account *"
                defaultValue={`(${endorseOwnerShipName}) ${parties?.nominatedOwner}`}
                disabled={true}
                name="owner_account_address"
            />

        </Modal>
    )
}

